import * as FeatherIcons from 'react-feather';

export default FeatherIcons;
